import { render, staticRenderFns } from "./RequestTicket.vue?vue&type=template&id=087ace44&"
import script from "./RequestTicket.vue?vue&type=script&lang=js&"
export * from "./RequestTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports